<lib-message [type]="'tip'" [dismissId]="'packagesTip'" [className]="'push-bottom'">
	<div>
		With packages, you can easily create and offer services like "6-Month Coaching" or "10 Personal Training
		Sessions" to your clients. Each package includes a description and pricing details.
	</div>
	<div class="push-top-sm">
		<strong>Important:</strong> While you can track and assign packages to clients, {{ originalAppName() }} does not
		handle any payments between trainers and clients. Payment arrangements remain between you and your clients.
	</div>
</lib-message>

@if (table(); as table) {
<lib-card>
	<lib-table [table]="table"></lib-table>
</lib-card>
}
